import WithRouteLocationState from 'broker/components/WithRouteLocationState';
import { RouteKey } from 'broker/enums';
import { ExpiringPolicyContent } from './ExpiringPolicyContent';

export default function EditExpiringPolicy() {
  return (
    <WithRouteLocationState routeKey={RouteKey.EditExpiringPolicy} isStateRequired={false}>
      {() => <ExpiringPolicyContent />}
    </WithRouteLocationState>
  );
}
